const store = {
    posts: [],
    selectedPost: undefined
}
  
export default store
  


// WEBPACK FOOTER //
// ./src/store.js